import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

export type TimeZone = 'UTC' | 'local';

type TimeZoneState = {
  timeZone: TimeZone;
  setTimeZone: (value: TimeZone) => void;
};

const initialTimeZone: TimeZone = localStorage.getItem('timeZone') === 'UTC' ? 'UTC' : 'local';

export const TimeZoneContext = createContext<TimeZoneState>({
  timeZone: initialTimeZone,
  setTimeZone: () => undefined,
});

export const useTimeZone = () => useContext(TimeZoneContext);

export const TimeZoneProvider = ({ children }: { children: ReactNode }) => {
  const [timeZone, setTimeZone] = useState<TimeZone>(initialTimeZone);
  const state = useMemo(() => ({ timeZone, setTimeZone }), [timeZone, setTimeZone]);

  return <TimeZoneContext.Provider value={state}>{children}</TimeZoneContext.Provider>;
};
